import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JqGridComponent } from './grid.component';
import { JqGridService } from './grid.service';
@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [JqGridComponent],
  exports: [JqGridComponent],
  entryComponents: [JqGridComponent],
  providers: [JqGridService]
})
export class JqGridModule { }
